// ===============================
// Collection back-restore for Ajaxinate + Searchspring
// ===============================
(function () {
  var COLLECTION_PREFIX = "/collections/";
  var PRODUCT_PREFIX = "/products/";

  function normalizedCollectionKey(pathname, search) {
    if (!pathname || pathname.indexOf(COLLECTION_PREFIX) !== 0) return "";

    var parsed = new URL(pathname + (search || ""), location.origin);
    var params = new URLSearchParams(parsed.search || "");
    var remove = ["page", "pb", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    for (var i = 0; i < remove.length; i++) params.delete(remove[i]);

    var sorted = Array.from(params.entries()).sort(function (a, b) {
      if (a[0] === b[0]) return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
      return a[0] < b[0] ? -1 : 1;
    });

    var rebuilt = new URLSearchParams();
    for (var j = 0; j < sorted.length; j++) rebuilt.append(sorted[j][0], sorted[j][1]);
    var query = rebuilt.toString();

    return query ? parsed.pathname + "?" + query : parsed.pathname;
  }

  function stateKeyFor(pathname, search) {
    var normalized = normalizedCollectionKey(pathname, search);
    return normalized ? "collectionState:" + normalized : "";
  }

  function readStateByKey(key) {
    if (!key) return null;
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  function writeStateByKey(key, state) {
    if (!key) return;
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (_) {}
  }

  function collectionEnhancements() {
    var key = stateKeyFor(location.pathname, location.search);
    if (!key) return;

    var state = readStateByKey(key) || {};
    state.loadedPages = parseInt(state.loadedPages, 10);
    if (!isFinite(state.loadedPages) || state.loadedPages < 1) state.loadedPages = 1;
    state.scrollY = parseInt(state.scrollY, 10);
    if (!isFinite(state.scrollY) || state.scrollY < 0) state.scrollY = 0;
    state.lastNonZeroScrollY = parseInt(state.lastNonZeroScrollY, 10);
    if (!isFinite(state.lastNonZeroScrollY) || state.lastNonZeroScrollY < 0) state.lastNonZeroScrollY = 0;
    state.pendingBackRestoreAt = parseInt(state.pendingBackRestoreAt, 10);
    if (!isFinite(state.pendingBackRestoreAt) || state.pendingBackRestoreAt < 0) state.pendingBackRestoreAt = 0;
    state.pendingSnapshotAt = parseInt(state.pendingSnapshotAt, 10);
    if (!isFinite(state.pendingSnapshotAt) || state.pendingSnapshotAt < 0) state.pendingSnapshotAt = 0;
    state.pendingSnapshotY = parseInt(state.pendingSnapshotY, 10);
    if (!isFinite(state.pendingSnapshotY) || state.pendingSnapshotY < 0) state.pendingSnapshotY = 0;
    state.pendingSnapshotPages = parseInt(state.pendingSnapshotPages, 10);
    if (!isFinite(state.pendingSnapshotPages) || state.pendingSnapshotPages < 0) state.pendingSnapshotPages = 0;

    function hasFreshPendingRestore(s) {
      var t = s && s.pendingBackRestoreAt ? parseInt(s.pendingBackRestoreAt, 10) : 0;
      return !!(isFinite(t) && t > 0 && (Date.now() - t) < 30 * 60 * 1000);
    }

    var navEntry = performance && performance.getEntriesByType
      ? performance.getEntriesByType("navigation")[0]
      : null;
    var navType = navEntry && navEntry.type ? navEntry.type : "";
    if (navType !== "back_forward" && !hasFreshPendingRestore(state)) {
      state.loadedPages = 1;
      state.scrollY = 0;
      state.lastNonZeroScrollY = 0;
      state.pendingSnapshotAt = 0;
      state.pendingSnapshotY = 0;
      state.pendingSnapshotPages = 0;
    }

    function persistState() {
      state.updatedAt = Date.now();
      writeStateByKey(key, state);
    }

    function ensureRestoreStyles() {
      if (document.getElementById("CollectionRestoreStyles")) return;
      var style = document.createElement("style");
      style.id = "CollectionRestoreStyles";
      style.textContent =
        "#AjaxinateContainer{transition:opacity .24s ease,transform .24s ease;will-change:opacity,transform;}" +
        "html.collection-restore-active #AjaxinateContainer{opacity:.06;transform:translateY(6px);}" +
        "@media (prefers-reduced-motion: reduce){" +
        "#AjaxinateContainer{transition:none !important;}" +
        "html.collection-restore-active #AjaxinateContainer{transform:none !important;}" +
        "}";
      document.head.appendChild(style);
    }

    function beginRestoreVisualState() {
      ensureRestoreStyles();
      document.documentElement.classList.add("collection-restore-active");
    }

    function endRestoreVisualState() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          document.documentElement.classList.remove("collection-restore-active");
        });
      });
    }

    function rebindInteractiveCollectionUi() {
      if (typeof window.addProductOverlayEventListeners === "function") {
        window.addProductOverlayEventListeners();
      }
      if (typeof window.applyHoverEffectToProducts === "function") {
        var products = document.querySelectorAll("#AjaxinateContainer .ProductItem");
        if (products && products.length) window.applyHoverEffectToProducts(products);
      }
      if (typeof attachRestockListeners === "function") {
        attachRestockListeners();
      }
    }

    function clearStaleMobileOverlayState() {
      document.body.classList.remove("no-scroll");
      document.querySelectorAll(".ProductOverlayWrapper.active, .ProductOverlay.active").forEach(function (el) {
        el.classList.remove("active");
      });
    }

    function currentLoadedPagesFromDom() {
      var pagination = document.querySelector("#AjaxinatePagination");
      if (!pagination) return state.loadedPages;

      var nextLink = pagination.querySelector("a, .Pagination__Next");
      if (!nextLink || !nextLink.href) return state.loadedPages;

      try {
        var nextUrl = new URL(nextLink.href, location.origin);
        var rawPage = nextUrl.searchParams.get("page");
        var nextPage = rawPage ? parseInt(rawPage, 10) : NaN;
        if (!isFinite(nextPage) || nextPage < 2) return state.loadedPages;
        return nextPage - 1;
      } catch (_) {
        return state.loadedPages;
      }
    }

    if ("scrollRestoration" in history) history.scrollRestoration = "manual";

    var saveTimer = null;
    function persistCurrentScrollSnapshot(strictGuard) {
      if (window.__COLLECTION_RESTORING) return;
      if (hasFreshPendingRestore(state) && strictGuard) return;

      var y = window.scrollY || 0;
      if (strictGuard) {
        // Guard against transient top snaps during navigation/re-render.
        var wasDeep = (state.scrollY || 0) > 420 || (state.lastNonZeroScrollY || 0) > 420;
        if (wasDeep && y < 40) return;
      }

      state.loadedPages = Math.max(state.loadedPages, currentLoadedPagesFromDom());
      state.scrollY = y;
      if (y > 60) state.lastNonZeroScrollY = y;
      persistState();
    }

    function saveScroll() {
      if (hasFreshPendingRestore(state)) return;
      if (window.__COLLECTION_RESTORING) return;
      if (saveTimer) return;
      saveTimer = setTimeout(function () {
        saveTimer = null;
        if (hasFreshPendingRestore(state)) return;
        if (window.__COLLECTION_RESTORING) return;
        persistCurrentScrollSnapshot(false);
      }, 120);
    }
    window.addEventListener("scroll", saveScroll, { passive: true });
    window.addEventListener("pagehide", function () {
      persistCurrentScrollSnapshot(true);
      window.__COLLECTION_RESTORE_DONE = false;
    });
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        persistCurrentScrollSnapshot(true);
      }
    });

    function markPageLoaded() {
      if (window.__COLLECTION_RESTORING) return;
      state.loadedPages += 1;
      persistState();
    }

    function runCollectionCallbacks() {
      if (typeof ensureVisibility === "function") ensureVisibility();
      if (typeof window.addProductOverlayEventListeners === "function") {
        window.addProductOverlayEventListeners();
      }
      if (typeof updateStockMessage === "function") {
        document.querySelectorAll("#AjaxinateContainer [data-inventory]").forEach(function (element) {
          updateStockMessage(element);
        });
      }
      if (typeof attachRestockListeners === "function") {
        attachRestockListeners();
      }
    }

    function initAjaxinate() {
      if (typeof Ajaxinate !== "function") return false;
      if (window.__AJAXINATE_INITED) return true;

      var container = document.querySelector("#AjaxinateContainer");
      var pagination = document.querySelector("#AjaxinatePagination");
      if (!container || !pagination) return false;

      var nextLink = pagination.querySelector("a, .Pagination__Next");
      if (!nextLink) return false;

      window.__AJAXINATE_INITED = true;

      try {
        window.__AJAXINATE_INSTANCE = new Ajaxinate({
          container: "#AjaxinateContainer",
          pagination: "#AjaxinatePagination",
          method: "scroll",
          offset: 200,
          userScrollOnly: true,
          callback: function () {
            markPageLoaded();
            runCollectionCallbacks();
          }
        });
        return true;
      } catch (e) {
        console.log("[custom.js] Ajaxinate init failed", e);
        return false;
      }
    }

    function armAjaxinate() {
      if (window.__AJAXINATE_INSTANCE) window.__AJAXINATE_INSTANCE.userHasInteracted = true;
    }

    function armOnGesture() {
      armAjaxinate();
      document.removeEventListener("wheel", armOnGesture);
      document.removeEventListener("touchstart", armOnGesture);
      document.removeEventListener("keydown", armOnGesture);
      document.removeEventListener("mousedown", armOnGesture);
    }
    document.addEventListener("wheel", armOnGesture, { passive: true });
    document.addEventListener("touchstart", armOnGesture, { passive: true });
    document.addEventListener("keydown", armOnGesture);
    document.addEventListener("mousedown", armOnGesture);

    function captureProductNavFromEvent(e) {
      if (!e || !e.target) return;
      if (e.target.closest && (
        e.target.closest('.open-overlay_mobile') ||
        e.target.closest('.ProductOverlay') ||
        e.target.closest('.ProductOverlayWrapper') ||
        e.target.closest('.variant-selector-btn_product') ||
        e.target.closest('.ProductOverlay__Close')
      )) {
        return;
      }

      var directLink = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      var resolvedLink = directLink;

      // Some themes navigate from card wrappers via JS; resolve product URL from the card.
      if (!resolvedLink) {
        var card = e.target.closest ? e.target.closest(".ProductItem") : null;
        if (card) {
          resolvedLink = card.querySelector('a[href*="/products/"]');
        }
      }

      if (!resolvedLink || !resolvedLink.href) return;
      if (resolvedLink.href.indexOf(PRODUCT_PREFIX) === -1) return;

      state.loadedPages = Math.max(state.loadedPages, currentLoadedPagesFromDom());
      state.scrollY = window.scrollY || 0;
      if (state.scrollY > 60) state.lastNonZeroScrollY = state.scrollY;
      state.lastProductHref = resolvedLink.href;
      state.pendingBackRestoreAt = Date.now();
      state.pendingSnapshotAt = state.pendingBackRestoreAt;
      state.pendingSnapshotY = state.scrollY > 0 ? state.scrollY : state.lastNonZeroScrollY;
      state.pendingSnapshotPages = state.loadedPages;
      window.__COLLECTION_RESTORE_DONE = false;
      persistState();
    }

    document.addEventListener(
      "click",
      function (e) {
        captureProductNavFromEvent(e);
      },
      true
    );

    document.addEventListener(
      "mousedown",
      function (e) {
        captureProductNavFromEvent(e);
      },
      true
    );

    document.addEventListener(
      "touchstart",
      function (e) {
        captureProductNavFromEvent(e);
      },
      { passive: true, capture: true }
    );

    function focusLastProduct() {
      if (!state.lastProductHref) return;

      var parsed;
      try {
        parsed = new URL(state.lastProductHref, location.origin);
      } catch (_) {
        return;
      }

      var path = parsed.pathname;
      var link =
        document.querySelector('a[href*="' + path + '"]') ||
        document.querySelector('a[href="' + state.lastProductHref + '"]');

      if (link && typeof link.scrollIntoView === "function") {
        var rect = link.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) return;
        link.scrollIntoView({ block: "center", inline: "nearest" });
      }
    }

    function holdScrollAt(targetY, ms) {
      var endAt = Date.now() + (ms || 1800);
      var minHoldUntil = Date.now() + 420;
      var userInteracted = false;

      function stopHold() {
        if (Date.now() < minHoldUntil) return;
        userInteracted = true;
      }

      window.addEventListener("wheel", stopHold, { passive: true });
      window.addEventListener("touchstart", stopHold, { passive: true });
      window.addEventListener("keydown", stopHold);
      window.addEventListener("mousedown", stopHold);

      (function loop() {
        if (userInteracted || Date.now() >= endAt) {
          window.removeEventListener("wheel", stopHold);
          window.removeEventListener("touchstart", stopHold);
          window.removeEventListener("keydown", stopHold);
          window.removeEventListener("mousedown", stopHold);
          return;
        }

        if (Math.abs((window.scrollY || 0) - targetY) > 4) {
          window.scrollTo(0, targetY);
        }

        requestAnimationFrame(loop);
      })();
    }

    function stabilizeAfterRestore(targetY, ms) {
      var endAt = Date.now() + (ms || 4500);
      var userInteracted = false;

      function onUserAction() {
        userInteracted = true;
      }

      window.addEventListener("wheel", onUserAction, { passive: true });
      window.addEventListener("touchstart", onUserAction, { passive: true });
      window.addEventListener("keydown", onUserAction);
      window.addEventListener("mousedown", onUserAction);

      (function loop() {
        if (userInteracted || Date.now() >= endAt) {
          window.removeEventListener("wheel", onUserAction);
          window.removeEventListener("touchstart", onUserAction);
          window.removeEventListener("keydown", onUserAction);
          window.removeEventListener("mousedown", onUserAction);
          return;
        }

        var y = window.scrollY || 0;
        var jumpedNearTop = y < 80 && targetY > 220;
        var driftedFarUp = y + 240 < targetY;

        if (jumpedNearTop || driftedFarUp) {
          window.scrollTo(0, targetY);
        }

        setTimeout(loop, 120);
      })();
    }

    function fetchAndAppendNextPage() {
      return new Promise(function (resolve) {
        var pagination = document.querySelector("#AjaxinatePagination");
        var container = document.querySelector("#AjaxinateContainer");
        if (!pagination || !container) return resolve(false);

        var nextLink = pagination.querySelector("a, .Pagination__Next");
        if (!nextLink || !nextLink.href) return resolve(false);

        fetch(nextLink.href, { credentials: "same-origin" })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to load next collection page");
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var nextContainer = doc.querySelector("#AjaxinateContainer");
            var nextPagination = doc.querySelector("#AjaxinatePagination");
            if (!nextContainer) return resolve(false);

            container.insertAdjacentHTML("beforeend", nextContainer.innerHTML);
            pagination.innerHTML = nextPagination ? nextPagination.innerHTML : "";

            // During restore preloading we should not grow saved page depth,
            // otherwise each back cycle inflates depth and can jump near footer.
            runCollectionCallbacks();
            rebindInteractiveCollectionUi();

            if (window.__AJAXINATE_INSTANCE && typeof window.__AJAXINATE_INSTANCE.initialize === "function") {
              window.__AJAXINATE_INSTANCE.initialize();
            }

            resolve(true);
          })
          .catch(function () {
            resolve(false);
          });
      });
    }

    function canReachY(targetY) {
      return document.documentElement.scrollHeight >= (targetY + window.innerHeight + 120);
    }

    function restoreIfNeeded() {
      var latestState = readStateByKey(key);
      if (latestState && typeof latestState === "object") {
        state.lastProductHref = latestState.lastProductHref || state.lastProductHref || "";
        var latestScrollY = parseInt(latestState.scrollY, 10);
        if (isFinite(latestScrollY) && latestScrollY >= 0) state.scrollY = latestScrollY;
        var latestNonZero = parseInt(latestState.lastNonZeroScrollY, 10);
        if (isFinite(latestNonZero) && latestNonZero >= 0) state.lastNonZeroScrollY = latestNonZero;
        var latestPending = parseInt(latestState.pendingBackRestoreAt, 10);
        if (isFinite(latestPending) && latestPending >= 0) state.pendingBackRestoreAt = latestPending;
        var latestPendingSnapshotAt = parseInt(latestState.pendingSnapshotAt, 10);
        if (isFinite(latestPendingSnapshotAt) && latestPendingSnapshotAt >= 0) state.pendingSnapshotAt = latestPendingSnapshotAt;
        var latestPendingSnapshotY = parseInt(latestState.pendingSnapshotY, 10);
        if (isFinite(latestPendingSnapshotY) && latestPendingSnapshotY >= 0) state.pendingSnapshotY = latestPendingSnapshotY;
        var latestPendingSnapshotPages = parseInt(latestState.pendingSnapshotPages, 10);
        if (isFinite(latestPendingSnapshotPages) && latestPendingSnapshotPages >= 0) state.pendingSnapshotPages = latestPendingSnapshotPages;
        var latestPages = parseInt(latestState.loadedPages, 10);
        if (isFinite(latestPages) && latestPages >= 1) state.loadedPages = latestPages;
      }

      var shouldRestoreByNav = navType === "back_forward";
      var shouldRestoreByPending = hasFreshPendingRestore(state);
      var candidateY = (shouldRestoreByPending && state.pendingSnapshotY > 0)
        ? state.pendingSnapshotY
        : (state.scrollY > 0 ? state.scrollY : state.lastNonZeroScrollY);
      if ((!shouldRestoreByNav && !shouldRestoreByPending) || candidateY < 20 || window.__COLLECTION_RESTORE_DONE) return;

      window.__COLLECTION_RESTORE_DONE = true;
      window.__COLLECTION_RESTORING = true;
      beginRestoreVisualState();
      var restoreFailsafe = setTimeout(function () {
        window.__COLLECTION_RESTORING = false;
        document.documentElement.classList.remove("collection-restore-active");
      }, 2600);

      initAjaxinate();

      var targetY = parseInt(candidateY, 10);
      if (!isFinite(targetY) || targetY < 0) targetY = 0;
      if (targetY < 30 && state.lastNonZeroScrollY > 220) {
        targetY = state.lastNonZeroScrollY;
      }
      var safety = 0;

      function next() {
        safety += 1;
        if (canReachY(targetY) || safety > 25) {
          clearTimeout(restoreFailsafe);
          window.scrollTo(0, targetY);
          holdScrollAt(targetY, 1100);
          setTimeout(function () { holdScrollAt(targetY, 700); }, 700);
          setTimeout(function () { stabilizeAfterRestore(targetY, 4500); }, 1200);
          setTimeout(rebindInteractiveCollectionUi, 80);
          setTimeout(endRestoreVisualState, 220);
          state.loadedPages = Math.max(1, currentLoadedPagesFromDom());
          state.pendingBackRestoreAt = 0;
          state.pendingSnapshotAt = 0;
          state.pendingSnapshotY = 0;
          state.pendingSnapshotPages = 0;
          persistState();
          window.__COLLECTION_RESTORING = false;
          return;
        }

        fetchAndAppendNextPage().then(function (ok) {
          if (!ok) {
            clearTimeout(restoreFailsafe);
            window.scrollTo(0, targetY);
            holdScrollAt(targetY, 900);
            setTimeout(function () { holdScrollAt(targetY, 600); }, 650);
            setTimeout(function () { stabilizeAfterRestore(targetY, 3800); }, 1100);
            setTimeout(rebindInteractiveCollectionUi, 80);
            setTimeout(endRestoreVisualState, 220);
            state.loadedPages = Math.max(1, currentLoadedPagesFromDom());
            state.pendingBackRestoreAt = 0;
            state.pendingSnapshotAt = 0;
            state.pendingSnapshotY = 0;
            state.pendingSnapshotPages = 0;
            persistState();
            window.__COLLECTION_RESTORING = false;
            return;
          }
          setTimeout(next, 60);
        });
      }

      next();
    }

    document.addEventListener("DOMContentLoaded", function () {
      clearStaleMobileOverlayState();
      initAjaxinate();
    });

    document.addEventListener("searchspring.domReady", function () {
      clearStaleMobileOverlayState();
      initAjaxinate();
      rebindInteractiveCollectionUi();
      restoreIfNeeded();
    });

    window.addEventListener("pageshow", function () {
      clearStaleMobileOverlayState();
      document.documentElement.classList.remove("collection-restore-active");
      document.body.classList.remove("no-scroll");
      rebindInteractiveCollectionUi();
      restoreIfNeeded();
    });
  }

  function productFallbackMarker() {
    if (location.pathname.indexOf(PRODUCT_PREFIX) !== 0 || !document.referrer) return;

    try {
      var ref = new URL(document.referrer);
      var key = stateKeyFor(ref.pathname, ref.search);
      if (!key) return;

      var state = readStateByKey(key) || {};
      state.lastProductHref = location.href;
      state.pendingBackRestoreAt = Date.now();
      if (!state.pendingSnapshotAt) state.pendingSnapshotAt = state.pendingBackRestoreAt;
      if (!state.pendingSnapshotY) {
        var sY = parseInt(state.scrollY, 10);
        var nzY = parseInt(state.lastNonZeroScrollY, 10);
        state.pendingSnapshotY = isFinite(sY) && sY > 0 ? sY : (isFinite(nzY) && nzY > 0 ? nzY : 0);
      }
      state.updatedAt = Date.now();
      writeStateByKey(key, state);
    } catch (_) {}
  }

  if (location.pathname.indexOf(COLLECTION_PREFIX) === 0) {
    collectionEnhancements();
  } else if (location.pathname.indexOf(PRODUCT_PREFIX) === 0) {
    productFallbackMarker();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
    function openCartDrawer() {
        let cartDrawer = document.getElementById("sidebar-cart");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (cartDrawer) {
            cartDrawer.setAttribute("aria-hidden", "false");
            cartDrawer.classList.add("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.add("is-visible");
        }

        document.body.classList.add("cart-open");
    }

    function closeCartDrawer() {
        let cartDrawer = document.getElementById("sidebar-cart");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (cartDrawer) {
            cartDrawer.setAttribute("aria-hidden", "true");
            cartDrawer.classList.remove("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.remove("is-visible");
        }

        document.body.classList.remove("cart-open");
    }

    document.addEventListener("click", function (event) {
        let cartButton = event.target.closest("[data-action='open-cart']");
        let navButton = event.target.closest("[data-action='open-menu']");

        if (cartButton) {
            event.preventDefault();
            openCartDrawer();
        }

        if (navButton) {
            event.preventDefault();
            openMobileMenu();
        }
    });

    document.querySelectorAll("[data-action='close-drawer']").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            closeCartDrawer();
        });
    });

    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("PageOverlay")) {
            closeCartDrawer();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeCartDrawer();
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    function openMobileMenu() {
        let navMenu = document.getElementById("mobile-nav");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (navMenu) {
            navMenu.classList.add("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.add("is-visible");
        }

        document.body.classList.add("menu-open");
    }

    function closeMobileMenu() {
        let navMenu = document.getElementById("mobile-nav");
        let pageOverlay = document.querySelector(".PageOverlay");

        if (navMenu) {
            navMenu.classList.remove("is-visible");
        }

        if (pageOverlay) {
            pageOverlay.classList.remove("is-visible");
        }

        document.body.classList.remove("menu-open");
    }

    document.addEventListener("click", function (event) {
        if (event.target.matches("[data-action='open-menu']")) {
            event.preventDefault();
            openMobileMenu();
        }
    });

    document.querySelectorAll("[data-action='close-menu']").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            closeMobileMenu();
        });
    });

    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("PageOverlay")) {
            closeMobileMenu();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeMobileMenu();
        }
    });
});


//----- MOBILE HOVER

// Mobile Hover Images
document.addEventListener("DOMContentLoaded", function () {
    let pressTimer;
    let touchStartY = 0;
    let touchMoved = false;

    function isMobileScreen() {
        return window.innerWidth <= 1140;
    }

    function applyHoverEffectToProducts(products) {
        products.forEach((item) => {
            let firstImage = item.querySelector(".ProductItem__Image");
            let alternateImage = item.querySelector(".ProductItem__Image--alternate");

            if (!firstImage || !alternateImage) return;

            // Ensure alternate image is preloaded & positioned correctly
            alternateImage.style.opacity = "0";
            alternateImage.style.display = "block"; 
            alternateImage.style.position = "absolute";
            alternateImage.style.top = "0";
            alternateImage.style.left = "0";
            alternateImage.style.width = "100%";
            alternateImage.style.height = "100%";
            alternateImage.style.zIndex = "1"; 

            // Touchstart: Detect long press
            item.addEventListener("touchstart", function (e) {
                if (!isMobileScreen()) return;

                touchMoved = false;
                touchStartY = e.touches[0].clientY;

                pressTimer = setTimeout(() => {
                    if (!touchMoved) {
                        firstImage.style.transition = "opacity 0.2s ease-in-out";
                        firstImage.style.opacity = "0";

                        alternateImage.style.transition = "opacity 0.2s ease-in-out";
                        alternateImage.style.setProperty("opacity", "1", "important");
                        alternateImage.style.setProperty("display", "block", "important");
                    }
                }, 300);
            });

            // Touchmove: Detect scrolling
            item.addEventListener("touchmove", function (e) {
                let moveY = e.touches[0].clientY;
                if (Math.abs(moveY - touchStartY) > 100) {
                    touchMoved = true;
                    clearTimeout(pressTimer);
                }
            });

            // Touchend: Restore images if no scrolling
            item.addEventListener("touchend", function () {
                clearTimeout(pressTimer);
                if (!touchMoved) {
                    firstImage.style.opacity = "1";
                    alternateImage.style.opacity = "0";
                }
            });
        });
    }

    // Apply hover effect to initial products and expose globally
    applyHoverEffectToProducts(document.querySelectorAll(".ProductItem"));
    window.applyHoverEffectToProducts = applyHoverEffectToProducts;

    // Detect when new products are added via infinite scroll (Mobile Hover)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    if (node.classList.contains("ProductItem")) {
                        applyHoverEffectToProducts([node]);
                    } else {
                        let newProducts = node.querySelectorAll?.(".ProductItem");
                        if (newProducts && newProducts.length) {
                            applyHoverEffectToProducts(newProducts);
                        }
                    }
                }
            });
        });
    });

    const productContainer = document.querySelector("#AjaxinateContainer");
    if (productContainer) {
        observer.observe(productContainer, { childList: true, subtree: true });
    }

    // Tapping outside resets images
    document.addEventListener("touchstart", function (e) {
        if (!isMobileScreen()) return;
        if (!e.target.closest(".ProductItem")) {
            document.querySelectorAll(".ProductItem").forEach((item) => {
                let firstImage = item.querySelector(".ProductItem__Image");
                let alternateImage = item.querySelector(".ProductItem__Image--alternate");
                if (firstImage) firstImage.style.opacity = "1";
                if (alternateImage) alternateImage.style.opacity = "0";
            });
        }
    });
});


// Product Overlay
(function () {
  if (window.__PRODUCT_OVERLAY_BINDER_INITED) return;
  window.__PRODUCT_OVERLAY_BINDER_INITED = true;

  function isSmallScreen() {
    return window.innerWidth <= 1139;
  }

  function resolveOverlayFromCard(button, productId) {
    let card = button && button.closest ? button.closest('.ProductItem') : null;
    if (!card) return { overlayWrapper: null, overlay: null };

    let overlayWrapper =
      card.querySelector(`.ProductOverlayWrapper[data-product-id="${productId}"]`) ||
      card.querySelector('.ProductOverlayWrapper');

    if (!overlayWrapper) return { overlayWrapper: null, overlay: null };

    let overlay =
      overlayWrapper.querySelector(`#product-overlay-${productId}`) ||
      overlayWrapper.querySelector('.ProductOverlay');

    return { overlayWrapper, overlay };
  }

  function mountOverlayToBody(overlayWrapper) {
    if (!overlayWrapper || overlayWrapper.__overlayMountedToBody) return;
    let parent = overlayWrapper.parentNode;
    if (!parent || parent === document.body) return;
    overlayWrapper.__overlayOriginalParent = parent;
    overlayWrapper.__overlayOriginalNextSibling = overlayWrapper.nextSibling;
    document.body.appendChild(overlayWrapper);
    overlayWrapper.__overlayMountedToBody = true;
  }

  function restoreOverlayMount(overlayWrapper) {
    if (!overlayWrapper || !overlayWrapper.__overlayMountedToBody) return;
    let parent = overlayWrapper.__overlayOriginalParent;
    let nextSibling = overlayWrapper.__overlayOriginalNextSibling;

    if (parent && document.documentElement.contains(parent)) {
      if (nextSibling && nextSibling.parentNode === parent) {
        parent.insertBefore(overlayWrapper, nextSibling);
      } else {
        parent.appendChild(overlayWrapper);
      }
    }

    overlayWrapper.__overlayMountedToBody = false;
    overlayWrapper.__overlayOriginalParent = null;
    overlayWrapper.__overlayOriginalNextSibling = null;
  }

  function applyMobileOverlayViewportStyles(overlayWrapper, overlay) {
    if (!isSmallScreen() || !overlayWrapper || !overlay) return;

    overlayWrapper.style.setProperty('position', 'fixed', 'important');
    overlayWrapper.style.setProperty('top', '0', 'important');
    overlayWrapper.style.setProperty('left', '0', 'important');
    overlayWrapper.style.setProperty('right', '0', 'important');
    overlayWrapper.style.setProperty('bottom', '0', 'important');
    overlayWrapper.style.setProperty('width', '100vw', 'important');
    overlayWrapper.style.setProperty('height', '100vh', 'important');
    overlayWrapper.style.setProperty('z-index', '9999', 'important');
    overlayWrapper.style.setProperty('display', 'block', 'important');
    overlayWrapper.style.setProperty('pointer-events', 'auto', 'important');

    overlay.style.setProperty('position', 'absolute', 'important');
    overlay.style.setProperty('left', '0', 'important');
    overlay.style.setProperty('right', '0', 'important');
    overlay.style.setProperty('bottom', '0', 'important');
    overlay.style.setProperty('max-height', '88vh', 'important');
    overlay.style.setProperty('overflow', 'auto', 'important');
    overlay.style.setProperty('display', 'block', 'important');
    overlay.style.setProperty('pointer-events', 'auto', 'important');
  }

  function clearMobileOverlayViewportStyles(overlayWrapper, overlay) {
    if (!overlayWrapper || !overlay) return;

    [
      'position', 'top', 'left', 'right', 'bottom',
      'width', 'height', 'z-index', 'display', 'pointer-events'
    ].forEach(prop => overlayWrapper.style.removeProperty(prop));

    [
      'position', 'left', 'right', 'bottom',
      'max-height', 'overflow', 'display', 'pointer-events'
    ].forEach(prop => overlay.style.removeProperty(prop));
  }

  function clearAllOverlayViewportStyles() {
    document.querySelectorAll('.ProductOverlayWrapper').forEach(wrapper => {
      let overlay = wrapper.querySelector('.ProductOverlay');
      if (overlay) {
        clearMobileOverlayViewportStyles(wrapper, overlay);
      }
      restoreOverlayMount(wrapper);
    });
  }

  function closeAnyActiveOverlays() {
    document.querySelectorAll('.ProductOverlayWrapper.active').forEach(wrapper => {
      wrapper.classList.remove('active');
      let overlay = wrapper.querySelector('.ProductOverlay');
      if (overlay) {
        overlay.classList.remove('active');
        clearMobileOverlayViewportStyles(wrapper, overlay);
      }
    });

    document.querySelectorAll('.ProductOverlay.active').forEach(overlay => {
      overlay.classList.remove('active');
    });

    clearAllOverlayViewportStyles();
    document.body.classList.remove('no-scroll');
  }

  function openOverlay(event) {
    event.preventDefault();
    event.stopPropagation();

    document.documentElement.classList.remove('collection-restore-active');
    window.__COLLECTION_RESTORING = false;

    let productId = this.getAttribute('data-product-id');
    let local = resolveOverlayFromCard(this, productId);
    let overlayWrapper = local.overlayWrapper || document.getElementById(`product-overlay-wrapper-${productId}`);
    let overlay = local.overlay || document.getElementById(`product-overlay-${productId}`);
    let messageElement = overlay ? overlay.querySelector('.ProductOverlayMessage') : null;

    closeAnyActiveOverlays();

    if (overlayWrapper && overlay) {
      overlayWrapper.classList.add('active');
      overlay.classList.add('active');

      if (isSmallScreen()) {
        mountOverlayToBody(overlayWrapper);
        applyMobileOverlayViewportStyles(overlayWrapper, overlay);
        document.body.classList.add('no-scroll');
      }

      if (messageElement) {
        messageElement.innerHTML = "";
      }
    }
  }

  function closeOverlay(productId) {
    document.querySelectorAll(`.ProductOverlayWrapper[data-product-id="${productId}"]`).forEach(wrapper => {
      wrapper.classList.remove('active');
      let overlay = wrapper.querySelector(`#product-overlay-${productId}`) || wrapper.querySelector('.ProductOverlay');
      if (overlay) {
        overlay.classList.remove('active');
        clearMobileOverlayViewportStyles(wrapper, overlay);
      }
      restoreOverlayMount(wrapper);
    });

    if (!document.querySelector('.ProductOverlayWrapper.active, .ProductOverlay.active')) {
      document.body.classList.remove('no-scroll');
    }
  }

  function closeOverlayOnMouseLeave(event) {
    let productId = this.getAttribute('data-product-id');
    let overlayWrapper = document.getElementById(`product-overlay-wrapper-${productId}`);
    let overlay = document.getElementById(`product-overlay-${productId}`);

    if (!overlayWrapper || !overlay) return;
    if (event.relatedTarget && (overlay.contains(event.relatedTarget) || overlayWrapper.contains(event.relatedTarget))) {
      return;
    }

    if (!isSmallScreen()) {
      closeOverlay(productId);
    }
  }

  function handleCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    closeAnyActiveOverlays();
  }

  function handleVariantHover() {
    updateStockMessage(this);
  }

  function handleVariantClick(event) {
    event.preventDefault();
    event.stopPropagation();

    let variantId = this.getAttribute('data-variant-id');
    let inventoryCount = parseInt(this.getAttribute('data-inventory'), 10);
    let productId = this.closest('.ProductOverlayWrapper').getAttribute('data-product-id');

    if (inventoryCount === 0) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
    .then(response => response.json())
    .then(() => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      openCartDrawer();
      if (isSmallScreen()) {
        setTimeout(() => closeOverlay(productId), 300);
      }
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    });
  }

  function handleSoldoutMobileRestock(event) {
  event.preventDefault();
  event.stopPropagation();

  let variantId = this.getAttribute('data-variant-id');
  let productData = this.getAttribute('data-product');

  if (!variantId || !productData) {
    console.error("Missing product data or variant id.");
    return;
  }

  try {
    productData = JSON.parse(productData);
  } catch (e) {
    console.error("Error parsing product data", e);
    return;
  }

  if (window._RestockRocket) {
    if (typeof window._RestockRocket.closeModal === "function") {
      window._RestockRocket.closeModal();
    }
    window._RestockRocket.openModal(productData, variantId);
  } else {
    console.error("Stoq API (RestockRocket) is not loaded.");
  }
}

  function handleMobileOpenOverlay(event) {
    if (!isSmallScreen()) return;
    let now = Date.now();
    if (window.__MOBILE_ATC_LAST_OPEN && (now - window.__MOBILE_ATC_LAST_OPEN) < 280) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    window.__MOBILE_ATC_LAST_OPEN = now;
    openOverlay.call(this, event);
  }

  function openCartDrawer() {
    let cartDrawer = document.getElementById("sidebar-cart");
    let pageOverlay = document.querySelector(".PageOverlay");

    if (cartDrawer) {
      cartDrawer.setAttribute("aria-hidden", "false");
      cartDrawer.classList.add("is-visible");
    }
    if (pageOverlay) {
      pageOverlay.classList.add("is-visible");
    }
    document.body.classList.add("cart-open");
  }

  function addEventListeners() {
    document.querySelectorAll('.open-overlay').forEach(button => {
      button.removeEventListener('mouseenter', openOverlay);
      button.removeEventListener('mouseleave', closeOverlayOnMouseLeave);

      if (!isSmallScreen()) {
        button.addEventListener('mouseenter', openOverlay);
        button.addEventListener('mouseleave', closeOverlayOnMouseLeave);
      }
    });

    document.querySelectorAll('.open-overlay_mobile').forEach(button => {
      button.removeEventListener('click', handleMobileOpenOverlay);
      button.removeEventListener('touchend', handleMobileOpenOverlay);

      if (isSmallScreen()) {
        button.addEventListener('click', handleMobileOpenOverlay);
        button.addEventListener('touchend', handleMobileOpenOverlay);
      }
    });

    document.querySelectorAll('.ProductOverlay__Close').forEach(button => {
      button.removeEventListener('click', handleCloseClick);
      button.removeEventListener('touchend', handleCloseClick);
      button.addEventListener('click', handleCloseClick);
      button.addEventListener('touchend', handleCloseClick);
    });

    document.querySelectorAll('.variant-selector-btn_product').forEach(label => {
      label.removeEventListener('mouseenter', handleVariantHover);
      label.addEventListener('mouseenter', handleVariantHover);
    });

    document.querySelectorAll('.variant-selector-btn_product:not(.soldout)').forEach(label => {
      label.removeEventListener('click', handleVariantClick);
      label.removeEventListener('touchstart', handleVariantClick);

      if (isSmallScreen()) {
        label.addEventListener('touchstart', handleVariantClick);
      } else {
        label.addEventListener('click', handleVariantClick);
      }
    });

    document.querySelectorAll('.variant-selector-btn_product.soldout').forEach(label => {
  label.removeEventListener('click', handleSoldoutMobileRestock);
  label.removeEventListener('touchend', handleSoldoutMobileRestock);

  if (isSmallScreen()) {
    label.addEventListener('click', handleSoldoutMobileRestock);
    label.addEventListener('touchend', handleSoldoutMobileRestock);
  }
});
  }

  window.addProductOverlayEventListeners = addEventListeners;
  window.closeOverlay = closeOverlay;

  if (!window.__MOBILE_ATC_FALLBACK_DELEGATE_BOUND) {
    window.__MOBILE_ATC_FALLBACK_DELEGATE_BOUND = true;

    let delegatedFallback = function(event) {
      if (!isSmallScreen()) return;
      if (event.defaultPrevented) return;

      let button = event.target && event.target.closest ? event.target.closest('.open-overlay_mobile') : null;
      if (!button) return;

      handleMobileOpenOverlay.call(button, event);
    };

    document.addEventListener('click', delegatedFallback);
    document.addEventListener('touchend', delegatedFallback, { passive: false });
  }

  document.addEventListener('DOMContentLoaded', addEventListeners);
  document.addEventListener('searchspring.domReady', addEventListeners);
  window.addEventListener('resize', addEventListeners);
})();

// ProductList Transform Reset
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.ProductList').forEach(el => {
    el.style.transform = "none";
  });
  document.querySelectorAll('.ProductItem').forEach(el => {
    if (el.style && el.style.transform && el.style.transform !== "none") {
      el.style.transform = "none";
    }
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (!mutation.target || !mutation.target.style) return;
      if (mutation.target.style.transform && mutation.target.style.transform !== "none") {
        mutation.target.style.transform = "none";
      }
    });
  });

  document.querySelectorAll('.ProductList').forEach(el => {
    observer.observe(el, { attributes: true, attributeFilter: ["style"] });
  });
  document.querySelectorAll('.ProductItem').forEach(el => {
    observer.observe(el, { attributes: true, attributeFilter: ["style"] });
  });
});


// Stock Message and Restock Functionality
function updateStockMessage(element) {
    let overlay = element.closest('.ProductOverlay');
    if (!overlay) {
        console.error("Product overlay not found.");
        return;
    }
    let messageElement = overlay.querySelector('.ProductOverlayMessage');
    if (!messageElement) {
        console.error("Stock message element not found.");
        return;
    }
    let variantElements = overlay.querySelectorAll("[data-inventory]");
    if (!variantElements.length) {
        console.error("No variant elements found.");
        return;
    }
    let allVariantsSoldOut = true;
    let defaultProductData = null;
    let defaultVariantId = null;

    variantElements.forEach(variant => {
        let variantInventory = parseInt(variant.getAttribute('data-inventory'), 10);
        if (variantInventory > 0) {
            allVariantsSoldOut = false;
        }
        if (!defaultProductData || !defaultVariantId) {
            defaultProductData = variant.getAttribute('data-product');
            defaultVariantId = variant.getAttribute('data-variant-id');
        }
    });

    if (allVariantsSoldOut) {
        if (!defaultProductData || !defaultVariantId) {
            console.error("Missing product data or variant ID for fully sold-out product.");
            return;
        }
        defaultProductData = JSON.parse(defaultProductData);
        messageElement.innerHTML = `
            <span id="RestockCollectionView" style="cursor:pointer;">
                Out Of Stock. <span style="text-decoration:underline;">Notify me when available.</span>
            </span>`;
        attachRestockListener(messageElement, defaultProductData, defaultVariantId);
        return;
    }

    // Attach a mouseenter event on each variant that clears and then sets the message
    variantElements.forEach(variant => {
        variant.addEventListener("mouseenter", function () {
            // Always clear any previous message
            messageElement.innerHTML = "";
            let hoveredInventory = parseInt(variant.getAttribute('data-inventory'), 10);
            let hoveredProductData = variant.getAttribute('data-product');
            let hoveredVariantId = variant.getAttribute('data-variant-id');

            if (!hoveredProductData || !hoveredVariantId) {
                console.error("Missing product data or variant ID on hover.");
                return;
            }
            hoveredProductData = JSON.parse(hoveredProductData);

            if (hoveredInventory === 0) {
                messageElement.innerHTML = `<span id="RestockCollectionView" style="cursor:pointer;">Out Of Stock. <span style="text-decoration:underline;">Notify me when available.</span></span>`;
                attachRestockListener(messageElement, hoveredProductData, hoveredVariantId);
            } else if (hoveredInventory < 5) {
                messageElement.innerHTML = "Low Stock";
            } else {
                messageElement.innerHTML = "";
            }
        });
    });

    let initiallySelectedVariant = overlay.querySelector(".variant-selector-btn_product.selected");
    if (initiallySelectedVariant) {
        let initialInventory = parseInt(initiallySelectedVariant.getAttribute('data-inventory'), 10);
        let initialProductData = initiallySelectedVariant.getAttribute('data-product');
        let initialVariantId = initiallySelectedVariant.getAttribute('data-variant-id');

        if (initialInventory === 0) {
            messageElement.innerHTML = `<span id="RestockCollectionView" style="cursor:pointer;">Out Of Stock. <span style="text-decoration:underline;">Notify me when available.</span></span>`;
            attachRestockListener(messageElement, JSON.parse(initialProductData), initialVariantId);
        } else if (initialInventory < 5) {
            messageElement.innerHTML = "Low Stock";
        } else {
            messageElement.innerHTML = "";
        }
    }
}

function attachRestockListener(messageElement, productData, variantId) {
    let notifyButton = messageElement.querySelector('#RestockCollectionView');
    if (!notifyButton) return;
    let clonedButton = notifyButton.cloneNode(true);
    notifyButton.parentNode.replaceChild(clonedButton, notifyButton);
    clonedButton.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (window._RestockRocket) {
            window._RestockRocket.openModal(productData, variantId);
        } else {
            console.error("Stoq API (RestockRocket) is not loaded.");
        }
    });
}

function attachRestockListeners() {
    document.querySelectorAll("#RestockCollectionViewMobile").forEach(button => {
        button.addEventListener("click", function(event) {
            event.stopPropagation();
            event.preventDefault();

            let parentElement = button.closest(".ProductOverlay");
            if (!parentElement) return;
            let variantElement = parentElement.querySelector("[data-inventory]");
            if (!variantElement) {
                console.error("Variant data element not found.");
                return;
            }
            let productData = variantElement.getAttribute("data-product");
            let variantId = variantElement.getAttribute("data-variant-id");
            if (!productData || !variantId) {
                console.error("Missing product data or variant ID.");
                return;
            }
            productData = JSON.parse(productData);
            if (window._RestockRocket) {
                window._RestockRocket.openModal(productData, variantId);
            } else {
                console.error("Stoq API (RestockRocket) is not loaded.");
            }
        });
    });
}

// Initialize stock messages and restock listeners on page load
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-inventory]").forEach(element => {
        updateStockMessage(element);
    });
    attachRestockListeners();
});

window.addEventListener("searchspring.domReady", function () {
    document.querySelectorAll("[data-inventory]").forEach(element => {
        updateStockMessage(element);
    });
    attachRestockListeners();
});

// Additional MutationObserver for newly added products (if needed)
const infiniteScrollObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
                let newProducts = [];
                if (node.classList.contains("ProductItem")) {
                    newProducts.push(node);
                } else {
                    newProducts = node.querySelectorAll?.(".ProductItem");
                }
                if (newProducts && newProducts.length) {
                    window.applyHoverEffectToProducts(newProducts);
                    if (typeof window.addProductOverlayEventListeners === "function") {
                        window.addProductOverlayEventListeners();
                    }
                }
            }
        });
    });
});
const ajaxContainer = document.querySelector("#AjaxinateContainer");
if (ajaxContainer) {
    infiniteScrollObserver.observe(ajaxContainer, { childList: true, subtree: true });
}

// Product Video + Flickity swipe

document.addEventListener('DOMContentLoaded', function () {
  const slideshow = document.querySelector('.Product__Slideshow');
  if (!slideshow) return;

  const isMobile = window.matchMedia('(max-width: 1024px)').matches;

  // ---------------------------
  // Helpers: autoplay video
  // ---------------------------
  const forceAutoplay = (video) => {
    if (!video) return;

    video.muted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.loop = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('loop', '');
    video.removeAttribute('poster');

    video.play().catch(() => {
      const unlock = () => video.play().catch(() => {});
      document.addEventListener('touchstart', unlock, { once: true, passive: true });
      document.addEventListener('click', unlock, { once: true });
    });
  };

  const pauseAllVideos = () => {
    slideshow.querySelectorAll('.Product__SlideItem video').forEach((v) => {
      try { v.pause(); } catch (e) {}
    });
  };

  const playActiveVideo = () => {
    pauseAllVideos();
    const activeSlide = slideshow.querySelector('.Product__SlideItem.is-selected');
    if (!activeSlide) return;
    const video = activeSlide.querySelector('video');
    forceAutoplay(video);
  };

  // ---------------------------
  // Prevent Plyr/video from capturing taps (but don't kill page scrolling)
  // ---------------------------
  const nukeVideoPointerCapture = () => {
    if (!isMobile) return;

    slideshow.querySelectorAll(
      '.Product__SlideItem--video .plyr, ' +
      '.Product__SlideItem--video .plyr *, ' +
      '.Product__SlideItem--video video'
    ).forEach((el) => {
      el.style.pointerEvents = 'none';
    });
  };

  // ---------------------------
  // Create an overlay on video slides that:
  // - allows vertical page scroll
  // - forwards horizontal swipes to Flickity
  // ---------------------------
  const ensureSwipeCatcher = () => {
    if (!isMobile) return;

    slideshow.querySelectorAll('.Product__SlideItem--video').forEach((slide) => {

      let catcher = slide.querySelector('.VideoSwipeCatcher');
      if (!catcher) {
        catcher = document.createElement('div');
        catcher.className = 'VideoSwipeCatcher';
        slide.appendChild(catcher);
      }

      catcher.style.position = 'absolute';
      catcher.style.top = '0';
      catcher.style.left = '0';
      catcher.style.right = '0';
      catcher.style.bottom = '0';
      catcher.style.zIndex = '9999';
      catcher.style.background = 'transparent';
      catcher.style.pointerEvents = 'auto';

      // This is key:
      // allow vertical scroll; we will preventDefault only for horizontal intent
      catcher.style.touchAction = 'pan-y';
    });
  };

  const syncCatcherToSelectedSlide = () => {
    if (!isMobile) return;

    slideshow.querySelectorAll('.VideoSwipeCatcher').forEach((c) => {
      c.style.display = 'none';
    });

    const activeSlide = slideshow.querySelector('.Product__SlideItem.is-selected');
    if (activeSlide && activeSlide.classList.contains('Product__SlideItem--video')) {
      const catcher = activeSlide.querySelector('.VideoSwipeCatcher');
      if (catcher) catcher.style.display = 'block';
    }
  };

  // ---------------------------
  // Flickity wiring
  // ---------------------------
  let flkty = null;

  const attachToFlickity = () => {
    if (typeof Flickity === 'undefined') return false;

    flkty = Flickity.data(slideshow);
    if (!flkty) return false;

    try {
      flkty.options.draggable = true;
      flkty.options.wrapAround = true;
      flkty.bindDrag();
      flkty.resize();
    } catch (e) {}

    // Re-apply stuff when Flickity changes slides
    const reapply = () => {
      ensureSwipeCatcher();
      nukeVideoPointerCapture();
      syncCatcherToSelectedSlide();
      playActiveVideo();
    };

    flkty.on('ready', () => setTimeout(reapply, 120));
    flkty.on('select', () => setTimeout(reapply, 60));
    flkty.on('settle', () => setTimeout(reapply, 60));

    // Install touch-forwarding on the catcher overlays
    installTouchForwarding();

    return true;
  };

  // Forward horizontal touch gestures to Flickity when on the video slide
  const installTouchForwarding = () => {
    if (!isMobile) return;

    slideshow.querySelectorAll('.VideoSwipeCatcher').forEach((catcher) => {
      if (catcher.__touchForwardingInstalled) return;
      catcher.__touchForwardingInstalled = true;

      let startX = 0;
      let startY = 0;
      let mode = null;        // null | 'h' | 'v'
      let dragging = false;

      const getTouch = (e) => (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]);

      catcher.addEventListener('touchstart', (e) => {
        const t = getTouch(e);
        if (!t) return;

        startX = t.clientX;
        startY = t.clientY;
        mode = null;
        dragging = false;
      }, { passive: true });

      catcher.addEventListener('touchmove', (e) => {
        if (!flkty) return;

        const t = getTouch(e);
        if (!t) return;

        const dx = t.clientX - startX;
        const dy = t.clientY - startY;

        // decide intent once
        if (!mode) {
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
            mode = 'h';
          } else if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) {
            mode = 'v';
          } else {
            return;
          }
        }

        // vertical: do nothing, let page scroll
        if (mode === 'v') return;

        // horizontal: prevent page scroll + drive Flickity drag manually
        e.preventDefault();

        if (!dragging) {
          dragging = true;
          try {
            // These are available on Flickity instances (Unidragger)
            flkty.pointerDown(e, t);
          } catch (err) {}
        }

        try {
          flkty.pointerMove(e, t);
        } catch (err) {}
      }, { passive: false });

      const end = (e) => {
        if (!flkty) return;
        if (!dragging) return;

        const t = getTouch(e);
        dragging = false;
        mode = null;

        try {
          flkty.pointerUp(e, t);
        } catch (err) {}

        // Ensure autoplay resumes correctly after swipe
        setTimeout(() => {
          nukeVideoPointerCapture();
          syncCatcherToSelectedSlide();
          playActiveVideo();
        }, 80);
      };

      catcher.addEventListener('touchend', end, { passive: true });
      catcher.addEventListener('touchcancel', end, { passive: true });
    });
  };

  // ---------------------------
  // MutationObserver: Plyr mutates DOM after load
  // ---------------------------
  const observer = new MutationObserver(() => {
    ensureSwipeCatcher();
    nukeVideoPointerCapture();
    syncCatcherToSelectedSlide();
    installTouchForwarding();
  });

  observer.observe(slideshow, { childList: true, subtree: true });

  // Initial apply
  ensureSwipeCatcher();
  nukeVideoPointerCapture();
  syncCatcherToSelectedSlide();
  setTimeout(() => {
    ensureSwipeCatcher();
    nukeVideoPointerCapture();
    syncCatcherToSelectedSlide();
    installTouchForwarding();
  }, 300);

  // Poll until Flickity instance exists
  let tries = 0;
  const poll = setInterval(() => {
    tries += 1;
    if (attachToFlickity() || tries > 40) clearInterval(poll);
  }, 100);

  // Thumbnail click support
  document.querySelectorAll('.Product__SlideshowNavImage[data-media-id]').forEach((thumb) => {
    thumb.addEventListener('click', function () {
      const mediaId = this.getAttribute('data-media-id');
      if (!mediaId) return;

      setTimeout(() => {
        ensureSwipeCatcher();
        nukeVideoPointerCapture();
        syncCatcherToSelectedSlide();
        installTouchForwarding();

        const targetSlide = document.querySelector(`#Media${mediaId}`);
        if (targetSlide) forceAutoplay(targetSlide.querySelector('video'));
      }, 350);
    });
  });

  // Desktop-only in-view autoplay 
  if (window.innerWidth >= 1024) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const v = entry.target.querySelector('video');
          if (v && v.paused) forceAutoplay(v);
        }
      });
    }, { threshold: 0.75 });

    document.querySelectorAll('.Product__SlideItem--video').forEach((slide) => io.observe(slide));
  }
});
